<template>
  <vx-card :title="id === null ? 'Cadastrar Pessoa Jurídica' : 'Editar Pessoa Jurídica'">
    <vs-tabs :color="colorx" v-model="tabIndex">
      <vs-tab label="Dados Básicos">
        <LegalEntityForm :legalEntityId="id" :services="services"></LegalEntityForm>
      </vs-tab>
      <vs-tab label="Endereço" :disabled="isTabEnabled">
        <Address :services="services" :addressTypeList="addressTypeList" />
      </vs-tab>
      <vs-tab label="Telefone" :disabled="isTabEnabled">
        <Phone :services="services" />
      </vs-tab>
      <vs-tab label="Email" :disabled="isTabEnabled">
        <Email :services="services" :emailTypeList="emailTypeList" />
      </vs-tab>
      <vs-tab label="Unidade Organizacional" :disabled="isTabEnabled">
        <OrganizationalUnitList :services="services" :legalEntityId="id"></OrganizationalUnitList>
      </vs-tab>
      <vs-tab label="Formulários" :disabled="isTabEnabled">
        <vx-card>
          <vs-tabs :color="colorx">
            <vs-tab label="LGPD">
              <PrivacyRequest :legalEntityId="id"></PrivacyRequest>
            </vs-tab>
            <vs-tab label="Incidente">
              <incident :legalEntityId="id"></incident>
            </vs-tab>
            <vs-tab label="Due Diligence">
              <due-diligence :legalEntityId="id"></due-diligence>
            </vs-tab>
            <vs-tab label="Intimidação Sistemática">
              <systematic-intimidation :legalEntityId="id"></systematic-intimidation>
            </vs-tab>
            <vs-tab label="Formulário de Relato">
              <ReportingChannel :legalEntityId="id"></ReportingChannel>
            </vs-tab>
          </vs-tabs>
        </vx-card>
      </vs-tab>
      <!-- <vs-tab label="Dados Bancários" :disabled="isTabEnabled">
        <Bank :services="services" />
      </vs-tab> -->
      <!-- <vs-tab label="Documentos" :disabled="isTabEnabled">
        <Document :services="services" personType="PJ" />
      </vs-tab> -->
    </vs-tabs>
  </vx-card>
</template>

<script>
import Datepicker from 'educatena-vuejs-datepicker'
import { ptBR } from 'educatena-vuejs-datepicker/dist/locale'
import vSelect from 'vue-select'
import Constants from '../../../../util/Constants'

import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import PeopleService from '@/services/api/PeopleService'
import LegalEntityService from '@/services/api/LegalEntityService'
import NaturalEntityService from '@/services/api/NaturalEntityService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import FinancialInstitutionService from '@/services/api/FinancialInstitutionService'
import BankDetailService from '@/services/api/BankDetailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'
import DocumentTypeService from '@/services/api/DocumentTypeService'
import DocumentPeopleService from '@/services/api/DocumentPeopleService'
import OrganizationalUnitService from '@/services/api/OrganizationalUnitService'
import OrganizationalUnitSponsorService from '@/services/api/OrganizationalUnitSponsorService'
import PronounTreatmentService from '@/services/api/PronounTreatmentService'
import LegalEntitySponsorService from '@/services/api/LegalEntitySponsorService'

import LegalEntity from '../tabs/LegalEntity'
import Address from '../tabs/Address'
import Email from '../tabs/Email'
import Bank from '../tabs/Bank'
import Phone from '../tabs/Phone'
import Document from '../tabs/Document'
import OrganizationalUnitList from '../tabs/OrganizationalUnitList.vue'
import PrivacyRequest from './tabs/PrivacyRequest.vue'
import Incident from './tabs/Incident.vue'
import DueDiligence from './tabs/DueDiligence.vue'
import SystematicIntimidation from './tabs/SystematicIntimidation.vue'
import ReportingChannel from './tabs/ReportingChannel.vue'


import LegalEntityForm from '../tabs/LegalEntityForm'

export default {
  components: {
    Datepicker,
    vSelect,
    LegalEntity,
    Address,
    Email,
    Bank,
    Phone,
    Document,
    OrganizationalUnitList,
    LegalEntityForm,
    PrivacyRequest,
    Incident,
    DueDiligence,
    SystematicIntimidation,
    ReportingChannel
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    tabIndex: 0,
    federationUnitList: [],
    emailTypeList: [],
    addressTypeList: [],
    services: {
      federationUnitService: null,
      cityService: null,
      peopleService: null,
      legalEntityService: null,
      naturalEntityService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      financialInstitutionService: null,
      bankDetailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null,
      documentTypeService: null,
      documentPeopleService: null,
      organizationalUnitService: null,
      organizationalUnitSponsorService: null,
      pronounTreatmentService: null,
      legalEntitySponsorService: null
    },
    legalEntityReady: false
  }),
  methods: {
    save() {
      if (this.tabIndex === 0) {
        this.saveLegalEntity()
      }
    },
    legalEntityUpdated() {
      this.legalEntityReady = true
    }
  },
  computed: {
    isTabEnabled() {
      return this.id === null
    }
  },
  mounted() {},
  beforeMount() {
    this.$vs.loading()

    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.peopleService = PeopleService.build(this.$vs)
    this.services.legalEntityService = LegalEntityService.build(this.$vs)
    this.services.naturalEntityService = NaturalEntityService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.financialInstitutionService = FinancialInstitutionService.build(
      this.$vs
    )
    this.services.bankDetailService = BankDetailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
    this.services.documentTypeService = DocumentTypeService.build(this.$vs)
    this.services.documentPeopleService = DocumentPeopleService.build(this.$vs)
    this.services.organizationalUnitService = OrganizationalUnitService.build(this.$vs)
    this.services.organizationalUnitSponsorService = OrganizationalUnitSponsorService.build(this.$vs)
    this.services.pronounTreatmentService = PronounTreatmentService.build(this.$vs)
    this.services.legalEntitySponsorService = LegalEntitySponsorService.build(this.$vs)

    this.services.emailTypeService.all().then(data => {
      this.emailTypeList = data
    })

    this.services.addressTypeService.all().then(
      data => {
        this.addressTypeList = data
        this.$vs.loading.close()
      },
      error => {
        this.$vs.loading.close()
      }
    )
  }
}
</script>
